import type {
  MqttBroker,
  MqttBrokerDto,
  MqttBrokerTestDto,
  MqttMetaDto,
  MqttTopicDecodeTestDto,
  MqttTopicDecodeTestResponseDto,
} from "~/types/api";
import type { ApiResponse } from "~/types/ui";
import { BaseAPI } from "./base";

export class MqttApi extends BaseAPI {
  async getBrokers(): Promise<ApiResponse<MqttBroker[]>> {
    return this.get<MqttBroker[]>(`mqtt/company/${this.company()}`);
  }
  async createBroker(payload: MqttBrokerDto): Promise<ApiResponse<void>> {
    return this.post<void>(`mqtt/${this.company()}`, payload);
  }

  async createOrUpdateMqttMeta(
    brokerId: string,
    deveui: string,
    payload: MqttMetaDto,
  ): Promise<ApiResponse<boolean>> {
    return this.post<boolean>(
      `mqtt/mqttmeta/create-or-update/${brokerId}/${deveui}`,
      payload,
    );
  }

  async testBroker(
    payload: MqttBrokerDto,
  ): Promise<ApiResponse<MqttBrokerTestDto>> {
    return this.post<MqttBrokerTestDto>(`mqtt/mqttbroker/test`, payload);
  }

  async testDecoder(
    payload: MqttTopicDecodeTestDto,
  ): Promise<ApiResponse<MqttTopicDecodeTestResponseDto[]>> {
    return this.post<MqttTopicDecodeTestResponseDto[]>(
      `mqtt/topic/decode/test`,
      payload,
    );
  }
}
